import { Route } from '@angular/router';
import { ShellStore } from '@kinet-open-network/client/shell/data-access';
import { UsersPickerStore } from '@kinet-open-network/client/users/data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    providers: [ShellStore, UsersPickerStore],
    loadChildren: () => import('@kinet-open-network/client/shell/feature'),
  },
];
